import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { message } from "antd";

const SelectChargeType = ({
  onSelectChargeType,
  selectedValue,
  isDisabled = false,
  isSearchable = false, // Match original isSearchable={false}
}) => {
  const [chargeTypes, setChargeTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchChargeTypes();
  }, []);

  const fetchChargeTypes = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${apiUrl}/extra-charges-codes/listings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (Array.isArray(response.data)) {
        // Filter for active charges and ensure charge_name and charge_type exist
        const activeChargeTypes = response.data
          .filter((charge) => charge.is_active === true && charge.charge_name && charge.charge_type)
          .map((charge) => ({
            value: charge.charge_type, // Use charge_type as value
            label: charge.charge_name, // Use charge_name as display label
            chargeDetails: charge,
          }));

        setChargeTypes(activeChargeTypes);
      } else {
        throw new Error("Invalid response format: Expected an array of charges");
      }
    } catch (error) {
      console.error("Error fetching charge types:", error);
      setError("Failed to load charge types. Please try again.");
      setChargeTypes([]); // No static options, so empty array
      message.error("Error fetching charge types.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Select
      options={chargeTypes}
      onChange={(selectedOption) => {
        // Pass both value (charge_type) and label (charge_name) as an object
        onSelectChargeType({
          value: selectedOption ? selectedOption.value : null,
          name: selectedOption ? selectedOption.label : null,
        });
      }}
      value={chargeTypes.find((option) => option.value === selectedValue?.value && option.label === selectedValue?.name) || null}
      placeholder="Select Charge Type"
      isLoading={loading}
      isDisabled={isDisabled || loading || !!error}
      noOptionsMessage={() =>
        error ? error : loading ? "Loading..." : "No active charge types available"
      }
      isClearable
      isSearchable={isSearchable}
    />
  );
};

export default SelectChargeType;